import '../styles/Users.css';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import { API } from '../config/api';

export default function Users() {
  const [searchType, setSearchType] = useState('nom');
  const [searchValue, setSearchValue] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [users, setUsers] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [form, setForm] = useState({
    nom: '', prenom: '', tel: '', email: '', password: '', role: ''
  });
  const token = localStorage.getItem('token');

  const fetchUsers = async () => {
    try {
      const res = await axios.get(API+'/api/users', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUsers(res.data);
    } catch (err) {
      console.error('❌ Erreur chargement utilisateurs :', err);
      alert('Erreur chargement utilisateurs');
    }
  };

  useEffect(() => {
    if (!token) {
      alert("Token manquant, veuillez vous reconnecter.");
      return;
    }
    fetchUsers();
  }, [token]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const openModal = (user = null) => {
    setEditingUser(user);
    setForm(user || { nom: '', prenom: '', tel: '', email: '', adresse: '', password: '', role: '' });
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingUser) {
        await axios.put(API+`/api/users/${editingUser.idtech}`, form, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } else {
        await axios.post(API+'/api/users', form, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }
      setShowModal(false);
      setEditingUser(null);
      setForm({ nom: '', prenom: '', tel: '', email: '', adresse: '', password: '', role: '' });
      fetchUsers();
    } catch (err) {
      alert("Erreur lors de l'enregistrement de l'utilisateur.");
      console.error(err);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Voulez-vous vraiment supprimer cet utilisateur ?")) {
      try {
        await axios.delete(API+`/api/users/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        fetchUsers();
      } catch (err) {
        console.error('Erreur suppression utilisateur :', err);
        alert("Erreur lors de la suppression de l'utilisateur.");
      }
    }
  };

  const filtered = users.filter(u => {
    const val = searchValue.toLowerCase();
    if (searchType === 'nom') return u.nom?.toLowerCase().includes(val);
    if (searchType === 'prenom') return u.prenom?.toLowerCase().includes(val);
    if (searchType === 'tel') return u.tel?.includes(val);
    return true;
  });

  return (
    <div className="users-page">
      <h1>Gestion des Utilisateurs</h1>

      <div className="users-header">
        <div className="users-filters">
          <select value={searchType} onChange={e => setSearchType(e.target.value)}>
            <option value="nom">Nom</option>
            <option value="prenom">Prénom</option>
            <option value="tel">Téléphone</option>
          </select>
          <input
            type="text"
            placeholder="Rechercher..."
            value={searchValue}
            onChange={e => setSearchValue(e.target.value)}
          />
        </div>
        <button className="users-btn-add" onClick={() => openModal(null)}>+ Ajouter Utilisateur</button>
      </div>

      <table className="users-table">
        <thead>
          <tr>
            <th>Nom</th>
            <th>Prénom</th>
            <th>Adresse</th>
            <th>Téléphone</th>
            <th>Email</th>
            <th>Rôle</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filtered.length > 0 ? filtered.map((u, i) => (
            <tr key={i}>
              <td>{u.nom}</td>
              <td>{u.prenom}</td>
              <td>{u.adresse}</td>
              <td>{u.tel}</td>
              <td>{u.email}</td>
              <td className={u.role === 'Admin' ? 'role admin' : 'role tech'}>{u.role}</td>
              <td>
                <button className="users-btn-edit" onClick={() => openModal(u)}><FaEdit /></button>
                <button className="users-btn-delete" onClick={() => handleDelete(u.idtech)}><FaTrashAlt /></button>
              </td>
            </tr>
          )) : (
            <tr><td colSpan="6">Aucun utilisateur trouvé.</td></tr>
          )}
        </tbody>
      </table>

      {showModal && (
        <div className="users-modal-overlay">
          <div className="users-modal">
            <h2>{editingUser ? 'Modifier' : 'Ajouter'} un Utilisateur</h2>
            <form onSubmit={handleSubmit}>
              <input name="nom" placeholder="Nom" value={form.nom} onChange={handleChange} required />
              <input name="prenom" placeholder="Prénom" value={form.prenom} onChange={handleChange} required />
              <input name="tel" placeholder="Téléphone" value={form.tel} onChange={handleChange} required />
              <input name="adresse" placeholder="Adresse" value={form.adresse} onChange={handleChange} required />
              <input name="email" type="email" placeholder="Email" value={form.email} onChange={handleChange} required />
              <input name="password" type="password" placeholder="Mot de passe" value={form.password} onChange={handleChange} required={!editingUser} />
              <select name="role" value={form.role} onChange={handleChange} required>
                <option value="">Sélectionner un rôle</option>
                <option value="Admin">Administrateur</option>
                <option value="Tech">Technicien</option>
              </select>
              <div className="users-modal-actions">
                <button type="submit">Enregistrer</button>
                <button type="button" onClick={() => setShowModal(false)}>Annuler</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <footer className="page-footer">
        <p>© 2025 Abar. Powered by <strong>Jysser Connect</strong></p>
      </footer>
    </div>
  );
}
